@import (reference) '../../../constants/spacing.module.less';
@import (reference) 'ui-components/components/text/text.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.react-table-wrapper {
  width: 100%;
  border-collapse: collapse;
}

.react-table-header-row {
  .label();
  background-color: var(--default--background-color--14);
}

.cell {
  display: flex;
  align-items: center;

  padding: @space-8 @space-16;
  overflow-wrap: anywhere;
}

.react-table-body-row {
  .paragraph();
  border-bottom: 1px solid var(--table--border-color--2);

  &:last-of-type {
    border-bottom: none;
  }
}

.loading-indicator {
  min-height: 100px;
}

.sort-icon {
  margin-left: @space-8;
  height: 15px;
  width: 15px;
  color: var(--grey-400);
}

.sorted-sort-icon {
  .sort-icon();
  color: var(--grey-400);
}
